import {
  BaseCreateUpdateTunnel,
  BaseInstallationDto,
  BaseTunnelFundingDto,
  BaseTunnelInstallationPrice,
  PricedItem,
  TunnelConfigurationWithInstallation,
  TunnelInstallation,
} from '../common-tunnel-dtos';
import { WorkbenchEan } from '../../applications/workbench/workbench-ean';
import { DiscountTypeEnum } from '../../../../enum/discount-type.enum';
import { ConfigurationHbm } from '../common-hbm-tunnel-dtos';

export type KitchenCreateUpdateTunnel = BaseCreateUpdateTunnel & {
  bom: string;
  uuidhbm: string;
  kitchenInspiration: KitchenInspirationDto;
};

export type KitchenInspirationDto = {
  styleId?: number;
  modelId?: number;
  layoutRef?: string;
  ovenConfigurationRef?: string;
  fridgeConfigurationRef?: string;
};

export type UpdateTunnelInput = {
  tunnelConfigurationId: string;
  updateTunnelRequest: KitchenCreateUpdateTunnel;
};

export type AddWorkbenchInput = {
  tunnelConfigurationId: string;
  workbenchConfigurationId: string;
};

export type BaseKitchenConfigurationDto = {
  id: string;
  kitchenConfigurationId: string;
  workbenchConfigurationId?: string;
  title?: string;
  bom?: string;
};

export type KitchenTunnelWorkbenchPrice = {
  workbench3DPrice?: PricedItem;
  workbenchPlanPrice?: PricedItem;
  workbenchProducts?: WorkbenchEan[];
  packagePrices?: {
    Installation: number;
    Transport: number;
  };
};

export type KitchenTunnelInstallationPriceDto = {
  price?: number;
  installationDetails?: string;
};

export type KitchenInstallationDto = BaseInstallationDto & {
  installationPrice?: KitchenTunnelInstallationPriceDto;
  workbenchPrices?: KitchenTunnelWorkbenchPrice;
  conceptionPrices?: KitchenTunnelConceptionPrice;
  complementaryProductPrice?: PricedItem;
  installationGeneric?: string;
};

export type KitchenTunnelFinancingDto = BaseTunnelFundingDto;

export type KitchenTunnelInstallationPrice = BaseTunnelInstallationPrice;

export type KitchenTunnelConceptionPrice = {
  delta?: number;
  withInstallation?: KitchenTunnelConceptionDetailPrice;
  withoutInstallation?: KitchenTunnelConceptionDetailPrice;
  conceptionPrices?: KitchenTunnelConceptionPrice;
  categoryTotals?: Record<string, PricedItem>;
};

export type KitchenTunnelConceptionDetailPrice = {
  totalPrice?: PricedItem;
  productsNonAppliancesPrice?: PricedItem;
  productsAppliancesPrice?: PricedItem;
};

export type KitchenTunnelPricingDto = {
  financing?: KitchenTunnelFinancingDto;
  financingWithInstallation?: KitchenTunnelFinancingDto;
  discountEnum: DiscountTypeEnum;
  installationPrices?: KitchenTunnelInstallationPrice;
  conceptionPrices?: KitchenTunnelConceptionPrice;
  workbenchPrices?: KitchenTunnelWorkbenchPrice;
  deliveryPrice?: PricedItem;
  complementaryProductPrice?: PricedItem;
  totalWithFinancing?: number;
  totalWithoutFinancing?: PricedItem;
  downPayment?: number;
  houseMoreThan2YearsOld: boolean;
  withInstallation: boolean;
};

export class KitchenInspiration {
  styleId?: number;
  modelId?: number;
  layoutRef?: string;
  ovenConfigurationRef?: string;
  fridgeConfigurationRef?: string;
}

export type KitchenTunnelConfiguration = TunnelConfigurationWithInstallation<KitchenInstallation> & {
  kitchenConfigurationId: string;
  workbenchConfigurationId?: string;
  inspirationId?: string;
  kitchenConfiguration: KitchenConfiguration;
  inspiration?: KitchenInspiration;
};

export type KitchenConfiguration = ConfigurationHbm & {
  isPrevisit: boolean;
  kitchenConfigurationId: string;
};

export type KitchenInstallation = TunnelInstallation & {
  houseMoreThan2YearsOld?: boolean;
  subtotalProduct?: number;
  productsPricesNonAppliances?: number;
  productsPricesAppliances?: number;
  subtotalProductDiscount?: number;
  productsPricesNonAppliancesDiscount?: number;
  productsPricesAppliancesDiscount?: number;
  InstallationGeneric?: string;
};

export type UpdateInspirationInput = {
  tunnelConfigurationId: string;
  inspirationData: KitchenInspirationDto;
};
